import styled from 'styled-components';
import { clearFix } from 'js/config/style';

export default styled.div`
  margin-top: ${({ spacing }) => (spacing ? spacing : 0)};
  ${clearFix}
`;
